// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────────────────────
   EndDayStockCount — redesigned styles
   Old rules kept as comments at the bottom for reference.
───────────────────────────────────────────────────────────────────────────── */

/* ── Layout shell ──────────────────────────────────────────────────────────── */
.edc-layout {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  background-color: #f8fafc;
  min-height: 100vh;
  box-sizing: border-box;
  margin-top: 40px;
}

/* ── Page header ───────────────────────────────────────────────────────────
   NOTE: the "End Day" header markup that used these classes has been
   commented out in the JSX (not present in the Replit reference), so these
   rules are currently unused. Kept here, not deleted, in case it's restored.
───────────────────────────────────────────────────────────────────────────── */
.edc-page-header {
  width: 100%;
  padding: 10px 4px;
}

.edc-page-title {
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* ── Main card ─────────────────────────────────────────────────────────────── */
.edc-card {
  width: 100%;
  /* background: #ffffff; */
  border-radius: 20px;
  /* border: 1px solid #e2e8f0; */
  /* box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06); */
  /* padding: 28px; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ── Card header ───────────────────────────────────────────────────────────── */
.edc-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.edc-card-title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edc-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.edc-card-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  max-width: 480px;
  line-height: 1.5;
}

/* ── Header right: badge + search ─────────────────────────────────────────── */
.edc-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.edc-progress-badge {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  border-radius: 14px;
  padding: 8px 16px;
  text-align: right;
  white-space: nowrap;
}

.edc-progress-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #2563eb;
  margin-bottom: 2px;
}

.edc-progress-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
}

/* ── Search box ────────────────────────────────────────────────────────────── */
.edc-search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  background: #f8fafc;
  min-width: 220px;
}

.edc-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #334155;
  width: 100%;
}

.edc-search-input::placeholder {
  color: #94a3b8;
}

/* ── Two-column body ───────────────────────────────────────────────────────── */
.edc-body-grid {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 20px;
  align-items: start;
}

@media (max-width: 1024px) {
  .edc-body-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Table wrapper ─────────────────────────────────────────────────────────── */
.edc-table-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

/* ── Stock input inside table cells ───────────────────────────────────────── */
.edc-stock-input {
  width: 100%;
  max-width: 120px;
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.edc-stock-input:focus {
  border-color: #2563eb;
}

.edc-stock-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

/* ── Sidebar ───────────────────────────────────────────────────────────────── */
.edc-sidebar {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.edc-sidebar-card {
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.edc-sidebar-card--light {
  background: #fff;
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.edc-sidebar-icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #fffbeb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edc-sidebar-card-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px 0;
}

.edc-sidebar-card-body {
  font-size: 12px;
  line-height: 1.6;
  color: #64748b;
  margin: 0;
}

.edc-sidebar-card--dark {
  background: #0f172a;
  color: #fff;
  border-color: #0f172a;
}

.edc-sidebar-next-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #94a3b8;
  margin: 0 0 10px 0;
}

.edc-sidebar-next-title {
  font-size: 15px;
  font-weight: 700;
  color: #f8fafc;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.edc-sidebar-next-body {
  font-size: 12px;
  line-height: 1.6;
  color: #94a3b8;
  margin: 0;
}

/* ── Footer ────────────────────────────────────────────────────────────────── */
.edc-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}

@media (max-width: 480px) {
  .edc-footer {
    flex-direction: column;
    gap: 12px;
  }
}

/* ── Footer buttons (plain CSS, replacing PosCustomButton) ───────────────────
   Mirrors the Replit reference exactly:
   - Back  -> bordered, white background, slate text
   - Close Day -> solid blue, white text, disabled state when not all rows are counted
─────────────────────────────────────────────────────────────────────────── */
.edc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  min-height: 40px;
  padding: 8px 32px;
  border-radius: 1.75rem;
  cursor: pointer;
  outline: none;
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease;
}

.edc-btn:focus-visible {
  box-shadow: 0 0 0 1px #94a3b8;
}

.edc-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.edc-btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.edc-btn-icon-left {
  margin-right: 0;
}

.edc-btn-icon-right {
  margin-left: 0;
}

/* Back button */
.edc-btn-back {
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  color: #0f1729;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.edc-btn-back:hover:not(:disabled) {
  background-color: #f8fafc;
}

.edc-btn-back:active:not(:disabled) {
  box-shadow: none;
}

/* Close Day button */
.edc-btn-close-day {
  border: none;
  background-color: #2563eb;
  color: #ffffff;
  box-shadow:
    0 10px 15px -3px rgba(37, 99, 235, 0.2),
    0 4px 6px -4px rgba(37, 99, 235, 0.2);
}

.edc-btn-close-day:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.edc-btn-close-day:active:not(:disabled) {
  box-shadow: none;
}

.edc-btn-close-day:disabled {
  background-color: #e2e8f0;
  color: #64748b;
  box-shadow: none;
}

/* ─────────────────────────────────────────────────────────────────────────────
   OLD styles — kept for reference
─────────────────────────────────────────────────────────────────────────────

.stock-count-container {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}

.layout-stock-count {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
}

.stock-count-end-day-header {
  width: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 7px;
}

.stock-count-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stock-count-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.search-box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.stock-table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 300px);
  margin-bottom: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  scroll-behavior: smooth;
}

.stock-table-wrapper::-webkit-scrollbar { width: 8px; height: 8px; }
.stock-table-wrapper::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.stock-table-wrapper::-webkit-scrollbar-thumb { background: #888; border-radius: 4px; }
.stock-table-wrapper::-webkit-scrollbar-thumb:hover { background: #555; }

.stock-table { width: 100%; min-width: 800px; border-collapse: collapse; background-color: #fff; }
.stock-table thead { background-color: #f8f9fa; }
.stock-table th { padding: 15px; text-align: left; font-weight: 600; font-size: 14px; color: #666; border-bottom: 2px solid #e0e0e0; white-space: nowrap; }
.stock-table th:nth-child(1) { width: 40%; }
.stock-table th:nth-child(2) { width: 15%; }
.stock-table th:nth-child(3) { width: 20%; }
.stock-table th:nth-child(4) { width: 25%; }
.stock-table td { padding: 15px; border-bottom: 1px solid #f0f0f0; font-size: 14px; color: #333; }
.stock-table tbody tr:hover { background-color: #f9f9f9; }

.stock-input { width: 100%; padding: 8px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; outline: none; box-sizing: border-box; }
.stock-input:focus { border-color: #4a90e2; }
.stock-input::placeholder { color: #999; }

.action-buttons { display: flex; justify-content: space-between; align-items: center; margin-top: 30px; }

.back-button { padding: 10px 30px; background-color: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; color: #333; cursor: pointer; transition: all 0.3s ease; }
.back-button:hover { background-color: #f5f5f5; }

.submit-button { padding: 10px 30px; background-color: #4a90e2; border: none; border-radius: 4px; font-size: 14px; color: #fff; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: all 0.3s ease; }
.submit-button:hover { background-color: #357abd; }

@media (max-width: 768px) {
  .search-box { justify-content: flex-start; }
  .search-input { width: 100%; }
  .stock-table th, .stock-table td { padding: 10px; font-size: 13px; }
  .action-buttons { flex-direction: column; gap: 15px; }
  .back-button, .submit-button { width: 100%; justify-content: center; }
}
*/
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/EndDayStockCount/EndDayStockCount.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,iFAAiF;AACjF;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;+EAI+E;AAC/E;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,iFAAiF;AACjF;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;;;;6EAI6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb;;;oBAGkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd;;yCAEuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA6FC","sourcesContent":["/* ─────────────────────────────────────────────────────────────────────────────\n   EndDayStockCount — redesigned styles\n   Old rules kept as comments at the bottom for reference.\n───────────────────────────────────────────────────────────────────────────── */\n\n/* ── Layout shell ──────────────────────────────────────────────────────────── */\n.edc-layout {\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: flex-start;\n  background-color: #f8fafc;\n  min-height: 100vh;\n  box-sizing: border-box;\n  margin-top: 40px;\n}\n\n/* ── Page header ───────────────────────────────────────────────────────────\n   NOTE: the \"End Day\" header markup that used these classes has been\n   commented out in the JSX (not present in the Replit reference), so these\n   rules are currently unused. Kept here, not deleted, in case it's restored.\n───────────────────────────────────────────────────────────────────────────── */\n.edc-page-header {\n  width: 100%;\n  padding: 10px 4px;\n}\n\n.edc-page-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n/* ── Main card ─────────────────────────────────────────────────────────────── */\n.edc-card {\n  width: 100%;\n  /* background: #ffffff; */\n  border-radius: 20px;\n  /* border: 1px solid #e2e8f0; */\n  /* box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06); */\n  /* padding: 28px; */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* ── Card header ───────────────────────────────────────────────────────────── */\n.edc-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.edc-card-title-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edc-card-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.edc-card-subtitle {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  max-width: 480px;\n  line-height: 1.5;\n}\n\n/* ── Header right: badge + search ─────────────────────────────────────────── */\n.edc-header-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.edc-progress-badge {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  border-radius: 14px;\n  padding: 8px 16px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.edc-progress-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #2563eb;\n  margin-bottom: 2px;\n}\n\n.edc-progress-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1;\n}\n\n/* ── Search box ────────────────────────────────────────────────────────────── */\n.edc-search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 8px 14px;\n  background: #f8fafc;\n  min-width: 220px;\n}\n\n.edc-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 14px;\n  color: #334155;\n  width: 100%;\n}\n\n.edc-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* ── Two-column body ───────────────────────────────────────────────────────── */\n.edc-body-grid {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 20px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .edc-body-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Table wrapper ─────────────────────────────────────────────────────────── */\n.edc-table-wrapper {\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n/* ── Stock input inside table cells ───────────────────────────────────────── */\n.edc-stock-input {\n  width: 100%;\n  max-width: 120px;\n  padding: 6px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.edc-stock-input:focus {\n  border-color: #2563eb;\n}\n\n.edc-stock-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* ── Sidebar ───────────────────────────────────────────────────────────────── */\n.edc-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.edc-sidebar-card {\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.edc-sidebar-card--light {\n  background: #fff;\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.edc-sidebar-icon-wrap {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: #fffbeb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edc-sidebar-card-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 6px 0;\n}\n\n.edc-sidebar-card-body {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #64748b;\n  margin: 0;\n}\n\n.edc-sidebar-card--dark {\n  background: #0f172a;\n  color: #fff;\n  border-color: #0f172a;\n}\n\n.edc-sidebar-next-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #94a3b8;\n  margin: 0 0 10px 0;\n}\n\n.edc-sidebar-next-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f8fafc;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n}\n\n.edc-sidebar-next-body {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #94a3b8;\n  margin: 0;\n}\n\n/* ── Footer ────────────────────────────────────────────────────────────────── */\n.edc-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}\n\n@media (max-width: 480px) {\n  .edc-footer {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n/* ── Footer buttons (plain CSS, replacing PosCustomButton) ───────────────────\n   Mirrors the Replit reference exactly:\n   - Back  -> bordered, white background, slate text\n   - Close Day -> solid blue, white text, disabled state when not all rows are counted\n─────────────────────────────────────────────────────────────────────────── */\n.edc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  min-height: 40px;\n  padding: 8px 32px;\n  border-radius: 1.75rem;\n  cursor: pointer;\n  outline: none;\n  transition:\n    background-color 0.15s ease,\n    box-shadow 0.15s ease,\n    color 0.15s ease;\n}\n\n.edc-btn:focus-visible {\n  box-shadow: 0 0 0 1px #94a3b8;\n}\n\n.edc-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.edc-btn-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.edc-btn-icon-left {\n  margin-right: 0;\n}\n\n.edc-btn-icon-right {\n  margin-left: 0;\n}\n\n/* Back button */\n.edc-btn-back {\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  color: #0f1729;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.edc-btn-back:hover:not(:disabled) {\n  background-color: #f8fafc;\n}\n\n.edc-btn-back:active:not(:disabled) {\n  box-shadow: none;\n}\n\n/* Close Day button */\n.edc-btn-close-day {\n  border: none;\n  background-color: #2563eb;\n  color: #ffffff;\n  box-shadow:\n    0 10px 15px -3px rgba(37, 99, 235, 0.2),\n    0 4px 6px -4px rgba(37, 99, 235, 0.2);\n}\n\n.edc-btn-close-day:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\n.edc-btn-close-day:active:not(:disabled) {\n  box-shadow: none;\n}\n\n.edc-btn-close-day:disabled {\n  background-color: #e2e8f0;\n  color: #64748b;\n  box-shadow: none;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   OLD styles — kept for reference\n─────────────────────────────────────────────────────────────────────────────\n\n.stock-count-container {\n  width: 100%;\n  padding: 20px;\n  background-color: #fff;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\n.layout-stock-count {\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.stock-count-end-day-header {\n  width: 100%;\n  padding: 10px;\n  background-color: #fff;\n  border-radius: 7px;\n}\n\n.stock-count-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stock-count-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.search-box {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.stock-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: calc(100vh - 300px);\n  margin-bottom: 30px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  scroll-behavior: smooth;\n}\n\n.stock-table-wrapper::-webkit-scrollbar { width: 8px; height: 8px; }\n.stock-table-wrapper::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }\n.stock-table-wrapper::-webkit-scrollbar-thumb { background: #888; border-radius: 4px; }\n.stock-table-wrapper::-webkit-scrollbar-thumb:hover { background: #555; }\n\n.stock-table { width: 100%; min-width: 800px; border-collapse: collapse; background-color: #fff; }\n.stock-table thead { background-color: #f8f9fa; }\n.stock-table th { padding: 15px; text-align: left; font-weight: 600; font-size: 14px; color: #666; border-bottom: 2px solid #e0e0e0; white-space: nowrap; }\n.stock-table th:nth-child(1) { width: 40%; }\n.stock-table th:nth-child(2) { width: 15%; }\n.stock-table th:nth-child(3) { width: 20%; }\n.stock-table th:nth-child(4) { width: 25%; }\n.stock-table td { padding: 15px; border-bottom: 1px solid #f0f0f0; font-size: 14px; color: #333; }\n.stock-table tbody tr:hover { background-color: #f9f9f9; }\n\n.stock-input { width: 100%; padding: 8px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; outline: none; box-sizing: border-box; }\n.stock-input:focus { border-color: #4a90e2; }\n.stock-input::placeholder { color: #999; }\n\n.action-buttons { display: flex; justify-content: space-between; align-items: center; margin-top: 30px; }\n\n.back-button { padding: 10px 30px; background-color: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; color: #333; cursor: pointer; transition: all 0.3s ease; }\n.back-button:hover { background-color: #f5f5f5; }\n\n.submit-button { padding: 10px 30px; background-color: #4a90e2; border: none; border-radius: 4px; font-size: 14px; color: #fff; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: all 0.3s ease; }\n.submit-button:hover { background-color: #357abd; }\n\n@media (max-width: 768px) {\n  .search-box { justify-content: flex-start; }\n  .search-input { width: 100%; }\n  .stock-table th, .stock-table td { padding: 10px; font-size: 13px; }\n  .action-buttons { flex-direction: column; gap: 15px; }\n  .back-button, .submit-button { width: 100%; justify-content: center; }\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
